import { render, staticRenderFns } from "./DodajObrazec.vue?vue&type=template&id=0e4c74f0&"
import script from "./DodajObrazec.vue?vue&type=script&lang=js&"
export * from "./DodajObrazec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports